import {
  Box,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

export default function CustomTable({
  rows,
  columns,
  showPagination,
  totalPages_,
  rowsPerPage_,
  currentPage_,
  headerBg,
  ref,
  getRowBg,
}) {
  const [currentPage, setCurrentPage] = React.useState(currentPage_);
  const [totalPages, setTotalPages] = React.useState(totalPages_);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPage_);
  const [rowsPerPageOptions, setRowsPerPageOptions] = React.useState([]);

  React.useEffect(() => {
    if (rows) {
      setRowsPerPageOptions([5, 10, 20, 50, 100]);
      setRowsPerPage(50);
      setTotalPages(Math.ceil(rows.length / 5));
    }
  }, [rows, rowsPerPage]);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage >= 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <TableContainer ref={ref} style={{ backgroundColor: "var(--bg-table)" }}>
      <Table className="custom-table" style={{ backgroundColor: "var(--bg-table)" }}>
        <Thead>
          <Tr border="none">
            {columns.map((column) => (
              <Th
                border="none"
                style={{
                  backgroundColor: headerBg || "var(--bg-table-header)",
                  color: "var(--text-table-header)",
                }}
              >
                {column.name}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {rows && rows.length > 0 ? (
            rows
              .slice(
                currentPage * rowsPerPage,
                currentPage * rowsPerPage + rowsPerPage
              )
              .map((row, index) => (
                <Tr
                  border="none"
                  className={getRowBg ? getRowBg(row, index) : ""}
                  style={
                    !getRowBg
                      ? {
                          backgroundColor:
                            index % 2 === 0
                              ? "var(--bg-table)"
                              : "var(--bg-table-row, var(--bg-card))",
                        }
                      : {}
                  }
                >
                  {columns.map((column) =>
                    column.element ? (
                      column.element(row, index)
                    ) : column.type == "date" ? (
                      <Td border="none">
                        <Text style={{ color: "var(--text-muted)" }}>{new Date(row[column.id]).toLocaleString()}</Text>
                      </Td>
                    ) : (
                      <>
                        <Td border="none">
                          {typeof row[column.id] == "string" ||
                          typeof row[column.id] == "number" ? (
                            <Text fontSize="sm" style={{ color: "var(--text-body)" }}>{row[column.id]}</Text>
                          ) : typeof row[column.id] == "boolean" ? (
                            <Switch
                              size="sm"
                              defaultChecked={
                                column.id == "isBetLocked"
                                  ? !row[column.id]
                                  : row[column.id]
                              }
                              isDisabled
                            />
                          ) : null}
                        </Td>
                      </>
                    )
                  )}
                </Tr>
              ))
          ) : (
            <Tr>
              <Td border="none" colSpan={columns.length}>
                <Box textAlign="center" py="40px">
                  <Text style={{ color: "var(--text-muted)" }}>No data available</Text>
                </Box>
              </Td>
            </Tr>
          )}
        </Tbody>
        {showPagination && (
          <Tfoot>
            <Tr>
              <Th colSpan={columns.length} style={{ backgroundColor: "var(--bg-table-header)" }}>
                <Box className="pagination-container">
                  <Text className="pagination-text" style={{ color: "var(--text-body)" }}>
                    Page {currentPage} of {totalPages}
                  </Text>
                  <Box gap={5}>
                    <button
                      className="pagination-button"
                      onClick={prevPage}
                      disabled={currentPage === 0}
                    >
                      <i className="fa fa-chevron-left"></i> Prev
                    </button>
                    <button
                      className="pagination-button"
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next <i className="fa fa-chevron-right"></i>
                    </button>
                  </Box>
                </Box>
              </Th>
            </Tr>
          </Tfoot>
        )}
      </Table>
    </TableContainer>
  );
}
